<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="industry_information_content warp">
      <div class="info_detail">
        <h2>{{ newsInfo.title }}</h2>
        <div class="info_detail_tips">
          <div class="info_detail_desc" v-html="newsInfo.content"></div>
        </div>
      </div>

      <div class="industry_information_recommender">
        <newsRecom
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh="getExpoList(4)"
          urlType="exhibition_detail"
        ></newsRecom>
        <div class="find_right" v-if="advList.length > 0">
          <a :href="'//' + advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRandomArray } from "@/utils/index";
import { activityInfo} from "@/api/coment"
import { getAdv } from "@/api/information";
import {getActivityList } from "@/api/information";
import {getToken} from '@/utils/auth'
import commBanner from "../../common/commBanner";
import newsRecom from "../../common/newsRecom";
import breadCrum from "../../common/breadCrum";
export default {
  inject:['reload'], //注入App里的reload方法
  components: {
    commBanner,
    newsRecom,
    breadCrum
  },
  data() {
    return {
      active:false,    
      obj: {       
        title: "展会详情",
        roleType:'',
        personalType:2,
      },
      breadCrumList: [
        { name: "平台展会", url: "/exhibition_list" },
        { name: "展会详情", url: "" },
      ],
      newsRecommendObj: {
        title: "推荐展会",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      newsInfo: {},
      allList: [],
      advType: 4,
      advList: [],
      imgs:[],
      type:'',
      id:''
    };
  },
  created() {
    let id = this.$route.query.id;
	  this.id = id;
    this.activityInfo(id)
    this.getAdv(); 
    this.getExhibitList();
    if(this.$store.state.user.userInfo != null){
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  watch: {
    $route: {
      handler: function (route) {
       // this.getTechnologyListById();
      },
      immediate: true,
    },
	type(val,oldval){
	    if(val == 0){
	      this.$router.push({
	        path: "/activity_detail",
	        query: { id: this.id },
	      });
	    }
	}
  },
  methods: {
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        if(res.code == 0){
          this.advList = res.page.list;
        }
      });
    },
    //获取展会详情
    activityInfo(id){
      activityInfo({id:id}).then((res)=>{
        if(res.code == 0){
          this.newsInfo = res.data;
		      this.type = res.data.type;
          this.imgs = res.data.cover.split(',');
        }
      }).catch((err)=>{})
    },

    //获取推荐技术内容 前端随机取4个
    getExhibitList() {
      getActivityList({
        recommend: 1,
        type:1
      }).then((res) => {
        if(res.code == 0){
          this.allList = res.page.list;
          this.getExpoList(4); 
        }
      });
    },
    getExpoList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },

    keepTextStyle(val){
      return (val +'').replace(/(<br[^>]*>|\s*)/g,'');
    },
    getMate(data){
      var metas = document.getElementsByTagName("meta"); 
      metas[0].name ="keyword" 
      metas[0].content= data.seokeywords
      metas[1].name ="description" 
      metas[1].content=data.seodescription
      document.getElementsByTagName("title")[0].innerText= data.title +'_智污邦环保服务平台';
    },


  },
};
</script>

<style scoped lang='less'>
/deep/.info_detail_desc{
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.industry_information_content {
  display: flex;

  .info_detail {
    width: 70%;
    margin-right: 30px;
    h2 {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .info_detail_tips {
      display: flex;
      flex-direction: column;
      .info_detail_date {
        flex: 6;
        margin-top: 20px;
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          margin-right: 20px;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      .user_operation {
        flex: 4;
      }
    }
    .info_detail_line {
      width: 100%;
      height: 1px;
      margin: 10px 0;
      background: #eeeeee;
    }
    .info_detail_desc {
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 2;
        text-indent: 2em;
        img {
          width: 100%;
          height: 364px;
        }
      }
    }
    .info_detail_next {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin: 35px 0;
      &:hover {
        color: blue;
      }
    }
  }

  .industry_information_recommender {
    width: 30%;
  }
  .find_right {
    margin-top: 10px;
    width: 100%;
    position: relative;
    span {
      position: absolute;
      top: 5px;
      left: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 184px;
    }
  }
}

.info_box{
  margin-top: 30px;
}
.info_box_img{
  margin-top: 20px;
  display: flex;
  justify-content: space-between !important;
}
.info_box_img img{
  width: 227px;
  height: 180px;
}
</style>



// WEBPACK FOOTER //
// src/view/other/exhibition_detail.vue